import axios from 'axios';
import { toast } from 'react-toastify';
const axiosInterceptor = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
});
axiosInterceptor.interceptors.request.use((config) => {
    config.headers["auth-token"] = localStorage.getItem("mnbfoundation");
    config.headers["auth-utoken"] = localStorage.getItem("mnbfutoken");
    return config;
}, (error) => {
    return Promise.reject(error);
});
axiosInterceptor.interceptors.response.use((response) => {
    return response.data;
}, (error) => {
    if(error?.response?.status===403){
        localStorage.removeItem('mnbfoundation');
        window.location.replace('/')
        return Promise.reject(error);
    }
    toast.error(error?.response?.messsage || error?.message)
    return { status: 0 };
}
);
export default axiosInterceptor;
